export * from './instalacion/instalacion.component';
export * from './instalacion/select-lugar-atencion/select-lugar-atencion.component';
export * from './introduccion/introduccion.component';
export * from './login/login.component';
export * from './signup/signup.component';
export * from './contactanos/contactanos.component';
